import { Patch } from "rfc6902";
import IErrorInfo from "../models/account/IErrorInfo";
import IAuction from "../models/auction/IAuction";
import IAuctionDetail from "../models/auction/IAuctionDetail";
import IAuctionStatus from "../models/auction/IAuctionStatus";
import ICreateUpdateAuction from "../models/auction/ICreateUpdateAuction";
import ICurrentAuctionState from "../models/auction/ICurrentAuctionState";
import HttpProvider from "../providers/HttpProvider";

export default class AuctionApi {
    public static async GetAuctions(
        includeDrafts: boolean
    ): Promise<IAuction[]> {
        const uriStr = `${this.apiUrl}/get-auctions`;
        const queryParams = { includeDrafts: includeDrafts.toString() };

        const response = await HttpProvider.GetRequest(uriStr, queryParams);
        if (!response.ok) {
            return [];
        }

        return (await response.json()) as IAuction[];
    }

    public static async GetAuction(
        url: string
    ): Promise<IAuctionDetail | null> {
        const uriStr = `${this.apiUrl}/get-auction`;
        const queryParams = { url };

        const response = await HttpProvider.GetRequest(uriStr, queryParams);
        if (!response.ok) {
            return null;
        }

        return (await response.json()) as IAuctionDetail;
    }

    public static async GetLiveAuctionInformation(
        auctionId: string,
        currentState: ICurrentAuctionState[]
    ): Promise<IAuctionStatus[]> {
        const uriStr = `${this.apiUrl}/auction-live-info/${auctionId}`;
        const response = await HttpProvider.PostRequest(uriStr, currentState);

        if (!response.ok) {
            return [];
        }

        return (await response.json()) as IAuctionStatus[];
    }

    public static async CreateAuction(
        newAuction: ICreateUpdateAuction
    ): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/create`;
        const response = await HttpProvider.PostRequest(uriStr, newAuction);
        if (!response.ok) {
            return (await response.json()) as IErrorInfo[];
        }

        return [];
    }

    public static async UpdateAuction(
        id: string,
        auctionPatch: Patch
    ): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/update/${id}`;
        const response = await HttpProvider.PatchRequest(uriStr, auctionPatch);
        if (!response.ok) {
            return (await response.json()) as IErrorInfo[];
        }

        return [];
    }

    public static async DeleteAuction(id: string): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/delete/${id}`;
        const response = await HttpProvider.DeleteRequest(uriStr);
        if (!response.ok) {
            return (await response.json()) as IErrorInfo[];
        }

        return [];
    }

    public static async PublishAuctions(): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/publish`;
        const response = await HttpProvider.PostRequest(uriStr);
        if (!response.ok) {
            return [{ description: "Error publishing...", code: "" }];
        }

        return [];
    }

    public static async SyncSalesSite(id: string): Promise<IErrorInfo[]> {
        const uriStr = `${this.apiUrl}/sync-sales-site/${id}`;
        const response = await HttpProvider.PostRequest(uriStr);
        if (!response.ok) {
            return [
                {
                    description:
                        "Error syncing sales site, please try again later.",
                    code: ""
                }
            ];
        }

        return [];
    }

    private static readonly apiUrl = "/api/Auction";
}
